import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { seoTemplatePageDetailLoad } from 'store/models/seoTemplatePage';
import { DetailLoadComponent } from 'components/common';

const PageValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={seoTemplatePageDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.tpl_title) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.seoTemplatePage,
  site: state.site,
});

export default connect(mapState)(PageValue);
